import React, { useState, useEffect } from 'react';
import { getDevOpsMembers, updateUserRole } from './api';
import './Equipo.css';

function Equipo() {
  const [miembros, setMiembros] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  useEffect(() => {
    cargarUsuarioActual();
    cargarMiembros();

    // Actualizar estado de presencia cada 30 segundos
    const interval = setInterval(() => {
      cargarMiembros();
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  const cargarUsuarioActual = async () => {
    try {
      const token = localStorage.getItem('token');
      if (token) {
        const response = await fetch('/api/auth/me', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        const user = await response.json();
        setCurrentUser(user);
      }
    } catch (error) {
      console.error('Error loading user:', error);
    }
  };

  const cargarMiembros = async () => {
    try {
      setLoading(true);
      const response = await getDevOpsMembers();
      setMiembros(response.data);
      setError(null);
    } catch (err) {
      console.error('Error al cargar miembros:', err);
      setError('Error al cargar los miembros del equipo');
    } finally {
      setLoading(false);
    }
  };

  const handleRoleChange = async (userId, newRole) => {
    try {
      await updateUserRole(userId, newRole);

      // Actualizar la lista de miembros
      setMiembros(miembros.map(m =>
        m.id === userId ? { ...m, role: newRole } : m
      ));

      setSuccessMessage('Rol actualizado correctamente');
      setTimeout(() => setSuccessMessage(null), 3000);
    } catch (err) {
      console.error('Error al actualizar rol:', err);
      setError(err.response?.status === 403
        ? 'No tienes permisos para modificar roles'
        : 'Error al actualizar el rol del usuario');
      setTimeout(() => setError(null), 3000);
    }
  };

  if (loading) {
    return <div className="loading">Cargando miembros del equipo...</div>;
  }

  const miembrosOnline = miembros.filter(m => m.is_online).length;
  const isAdmin = currentUser?.role === 'admin';

  return (
    <div className="equipo-container">
      <h2>Miembros del Equipo DevOps</h2>

      {error && (
        <div className="alert alert-error">
          <span className="alert-icon">⚠️</span>
          {error}
        </div>
      )}

      {successMessage && (
        <div className="alert alert-success">
          <span className="alert-icon">✓</span>
          {successMessage}
        </div>
      )}

      <div className="miembros-grid">
        {miembros.map((miembro) => (
          <div key={miembro.id || miembro.email} className="miembro-card">
            <div className="miembro-avatar-container">
              <div className="miembro-avatar">
                {miembro.name.split(' ').map(n => n[0]).join('').toUpperCase()}
              </div>
              <span
                className={`status-indicator ${miembro.is_online ? 'online' : 'offline'}`}
                title={miembro.is_online ? 'En línea' : 'Desconectado'}
              />
            </div>
            <div className="miembro-info">
              <h3>{miembro.name}</h3>
              <p className="miembro-email">{miembro.email}</p>
              <div className="miembro-status-role">
                <span className={`status-text ${miembro.is_online ? 'online' : 'offline'}`}>
                  {miembro.is_online ? '● En línea' : '○ Desconectado'}
                </span>
                <div className="role-selector">
                  <select
                    value={miembro.role || 'user'}
                    onChange={(e) => handleRoleChange(miembro.id, e.target.value)}
                    disabled={!isAdmin}
                    className={`role-select ${miembro.role === 'admin' ? 'role-admin' : 'role-user'}`}
                  >
                    <option value="user">Usuario</option>
                    <option value="admin">Admin</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="equipo-stats">
        <p>
          Total de miembros: <strong>{miembros.length}</strong>
          {' • '}
          En línea: <strong className="online-count">{miembrosOnline}</strong>
        </p>
      </div>
    </div>
  );
}

export default Equipo;
